const siteConfig = {
    name: 'Himanshu Kumar',
    slogan: 'Full Stack & AI Developer | OpenAI, Claude, RAG | React, Next.js, Node.js',
    description:
        'Full Stack & AI Developer with 12+ years of experience building web, mobile and AI applications for clients in the US, UK, Europe, Australia and Canada.',
    location: 'Ambala, Haryana, India',
    backgroundColor: '#060918',
    themeColor: '#6919FF',
    email: 'himanshukumar077@gmail.com',
    url: 'https://himanshu077.vercel.app',
    links: {
        github: 'https://github.com/himanshu077/',
    },
};

export default siteConfig;
